import React from "react";
import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function PrimaryButton({
  children,
  to,
  href,
  variant = "contained",
  color = "primary",
  size = "large",
  type = "button",
  disabled = false,
  fullWidth = false,
  onClick,
  sx,
  endIcon,
  startIcon,
}) {
  const common = {
    size,
    variant,
    color,
    type: href ? undefined : type,
    disabled,
    fullWidth,
    onClick,
    endIcon,
    startIcon,
    sx: { fontWeight: 600, ...sx },
  };

  if (to) {
    return (
      <Button component={RouterLink} to={to} {...common}>
        {children}
      </Button>
    );
  }

  if (href) {
    return (
      <Button component="a" href={href} target="_blank" rel="noopener noreferrer" {...common}>
        {children}
      </Button>
    );
  }

  return <Button {...common}>{children}</Button>;
}
